import React, { useContext, useEffect, useState } from 'react'
import { LocaleContext } from '../../contexts/LocaleContext';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from '../../services/toastService';
import { useValidation } from '../../hooks/useValidation';
import {urlConfig} from "../../config/baseUrl";
import BackButton from '../../components/common/BackButton';
import { createCitySchema } from '../../validation/citySchema';
import { cityService } from '../../services/cityService';
import Loading from '../../components/common/Loading';
import { SubTitle } from 'chart.js';
import { createBannerSchema } from '../../validation/bannerSchema';
import { bannerService } from '../../services/bannerService';
import { tripService } from '../../services/tripService';
import no_image_available from "../../assets/images/no_image_available.png";
import Select from "react-select";

const BannerForm = () => {

    const {t,lang} = useContext(LocaleContext);
    const { id } = useParams();
    const isEditMode=Boolean(id);
    const [isFilePicked, setIsFilePicked] = useState(false);
    const navigate = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [trips, setTrips] = useState(null);

    const initialForm = {
      title: "",
      titleEn: "",
      subtitle: "",
      subtitleEn: "",
      tripsId:[],
      file: null,
    };

     useEffect(()=>{
        loadData();
         if (isEditMode) editAsync();
    },[]);

    const loadData=async()=>{
        try{
            setLoading(true);
            await getAllTrips();
        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
        }
    }
  
     const getAllTrips = async () => {
       var data = await tripService.getDropdownAsync();
       setTrips(data);
     };

      const options = trips?.map((s) => ({
        value: s.value,
        label: s.label[lang],
        city: s.city?.[lang],
        image: s.imagePath,
      }));

    const v = useValidation();
    const schema = createBannerSchema(v, t, isEditMode);

  

    //validation
        const {
          register,
          handleSubmit,
          setValue,
          control,
          reset,
          formState: { errors },
          watch,
        } = useForm({
          defaultValues: initialForm,
          resolver: yupResolver(schema),
        });

         const handleClear = () => {
           reset(initialForm); // resets to initial values
         };

        const onSubmit = async (values) => {
          try {
            console.log(values);
            const formData = new FormData();
            // Append DTO fields
            Object.entries(values).forEach(([key, value]) => {
              if (value !== null && value !== undefined && key !== "file" && key !== "tripsId") {
                formData.append(key, value);
              }
            });
        
            // Append file (must match backend parameter name)
            if (values.file) {
              formData.append("file", values.file);
            }
            //add trips Id to form data
            values.tripsId.forEach((id, index) => {
              formData.append(`tripsId[${index}]`, id);
            });
            if (isEditMode) {
             await updateAsync(formData);
            } else {
              await addAsync(formData);
            }
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } 
        };
        const addAsync = async (formData) => {
          try {
            setBtnLoading(true);
            var response = await bannerService.create(formData);
            if (!response.isSuccess) {
              response.key?toast.error(t(response.key)): toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
              return;
            }
            toast.success(t("recordAddedSuccessfully"));
            navigate("/banners");
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } finally {
            setBtnLoading(false);
          }
        };
         const editAsync = async () => {
            try {
                setLoading(true);
            const response = await bannerService.edit(id);
        
            if (!response.isSuccess) {
              toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
              return;
            }
            const data = response.value;
            console.log(data);
            setPreviewImage(data.imagePath);
            reset({
              title: data.title,
              titleEn: data.titleEn,
              subtitle: data.subtitle,
              subtitleEn: data.subtitleEn,
              tripsId: data.tripsId,
            });
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
          };
        const updateAsync = async (formData) => {
          try {
            setBtnLoading(true);
            var response = await bannerService.update(id, formData);
            if (!response.isSuccess) {
               response.key
                 ? toast.error(t(response.key))
                 : toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
              return;
            }
            toast.success(t("recordUpdatedSuccessfully"));
            navigate("/banners");
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } finally {
            setBtnLoading(false);
          }
        };
        const deleteImage = async () => {
          try {
            setLoading(true);
            var response = await bannerService.deleteImageAsync(id);
            if (!response.isSuccess) {
              toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              return;
            } else {
              toast.success(t("recordDeletedSuccessfully"));
              setPreviewImage(null);
            }
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } finally {
            setLoading(false);
          }
        };

if(loading) return <Loading />
  return (
    <>
      <section className="provider-form">
        <div className="default-heading">
          {t("providersDashboardAndManagement")}
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="my-card">
            <div className="my-card-header d-flex justify-content-between align-items-center">
              {isEditMode ? (
                <>
                  <i className="fas fa-edit"></i> {t("editOrSelectedNarrator")}
                </>
              ) : (
                <>
                  <i className="fas fa-plus plus-icon"></i> {t("addNewBanner")}
                </>
              )}
              <BackButton />
            </div>
            <div className="my-card">
              <div className="my-card-header text-primary">
                {t("basicInformation")}
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {t("title")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      {...register("title")}
                      className="form-control"
                      placeholder={t("title")}
                    />
                    {errors.title && (
                      <p className="text-danger">{errors.title.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {t("titleEn")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("titleEn")}
                      {...register("titleEn")}
                    />
                    {errors.titleEn && (
                      <p className="text-danger">{errors.titleEn.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {t("subTitle")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      {...register("subtitle")}
                      className="form-control"
                      placeholder={t("subTitle")}
                    />
                    {errors.subTitle && (
                      <p className="text-danger">{errors.subtitle.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {t("subTitleEn")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      {...register("subtitleEn")}
                      className="form-control"
                      placeholder={t("subTitleEn")}
                    />
                    {errors.subTitleEn && (
                      <p className="text-danger">{errors.subtitleEn.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">{t("selectTrip")}</label>

                    <Select
                      isMulti
                      options={options}
                      value={options?.filter((o) =>
                        watch("tripsId")?.includes(o.value),
                      )}
                      placeholder={t("selectTrip")}
                      onChange={(selectedOptions) => {
                        const ids = selectedOptions
                          ? selectedOptions.map((opt) => opt.value)
                          : [];

                        setValue("tripsId", ids, {
                          shouldValidate: true,
                        });
                      }}
                      formatOptionLabel={(option, { context }) => {
                        // Selected value UI
                        if (context === "value") {
                          return (
                            <div className="d-flex align-items-center">
                              <img
                                src={
                                  option.image
                                    ? `${urlConfig.imageBaseUrl}/${option.image}`
                                    : no_image_available
                                }
                                width="28"
                                height="28"
                                style={{
                                  borderRadius: "50%",
                                  marginInlineEnd: 8,
                                  objectFit: "cover",
                                }}
                              />
                              <span>{option.label}</span>
                            </div>
                          );
                        }

                        // Dropdown UI
                        return (
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                option.image
                                  ? `${urlConfig.imageBaseUrl}/${option.image}`
                                  : no_image_available
                              }
                              width="45"
                              height="45"
                              style={{
                                borderRadius: 8,
                                marginInlineEnd: 10,
                                objectFit: "cover",
                              }}
                            />

                            <div>
                              <div style={{ fontWeight: 500 }}>
                                {option.label}
                              </div>

                              <small style={{ color: "#666" }}>
                                {option.city}
                              </small>
                            </div>
                          </div>
                        );
                      }}
                    />

                    {errors.tripsId && (
                      <p className="text-danger">{errors.tripsId.message}</p>
                    )}
                  </div>
                </div>
                {!previewImage ? (
                  <div className="col-12">
                    <div className="form-group">
                      <label className="form-label">{t("image")}</label>

                      <input
                        type="file"
                        id="provider-profile-picture"
                        className="d-none"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files?.[0];

                          setValue("file", file);
                          setIsFilePicked(Boolean(file));
                        }}
                      />

                      <label
                        htmlFor="provider-profile-picture"
                        className="my-file-upload"
                      >
                        <span>
                          {t("dragAndDropTheImageHereOr")}{" "}
                          <span className="text-primary">
                            {t("browseImages")} {isFilePicked && "(1)"}
                          </span>
                        </span>

                        <i className="fas fa-camera" />
                      </label>
                      {errors.file && (
                        <p className="text-danger">{errors.file.message}</p>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="col-12">
                    <div className="form-group">
                      <div className="preview-images">
                        <div className="preview-image">
                          <img
                            src={`${urlConfig.imageBaseUrl}/${previewImage}`}
                          />
                          <i
                            className="fas fa-times"
                            onClick={() => deleteImage()}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="mt-3 gap-2 d-flex justify-content-end">
              {!btnLoading && (
                <button type="submit" className="btn-default">
                  {t("save")}
                </button>
              )}
              {btnLoading && (
                <button type="button" className="btn-default">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </button>
              )}
              {isEditMode && (
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={handleClear}
                >
                  {t("reset")}
                </button>
              )}
              {!isEditMode && (
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={handleClear}
                >
                  {t("reset")}
                </button>
              )}
            </div>
          </div>
        </form>
      </section>
    </>
  );
}

export default BannerForm